import styled from 'styled-components';
import Typography from '../typography/Typography';
export const StatusWrapper = styled.div `
  padding: 0.8rem 1.8rem 1.9rem;
`;
export const Status = styled.div `
  &:not(:last-child) {
    margin-bottom: 0.8rem;
  }
`;
export const MarginInfoText = styled(Typography) `
  white-space: nowrap;
`;
//# sourceMappingURL=styles.js.map